import { LatestNewsLayout as MobileLatestNews } from '@/components/mo/LatestNews';
import { LatestNewsLayout as PcLatestNews } from '@/components/pc/LatestNews';
import { useIsMobile } from '@/hooks/useIsMobile';
import { Spin } from 'antd';
import styled from 'styled-components';

const LatestNewsIntroPage = () => {
  const isMobile = useIsMobile();

  if (isMobile === null) {
    return (
      <SpinnerWrapper>
        <Spin size="large" tip="로딩 중..." />
      </SpinnerWrapper>
    );
  }

  return isMobile ? <MobileLatestNews /> : <PcLatestNews />;
};

export default LatestNewsIntroPage;

// 중앙 정렬 스타일
const SpinnerWrapper = styled.div`
  display: flex;
  height: 100vh;
  align-items: center;
  justify-content: center;
`;
